import { Form, Upload, Button, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import './FileUploadField.style.less'

interface FileUploadFieldProps {
  label?: string
  name: string
  maxCount?: number
  allowLargeFile?: boolean
  accept?: string
  disabled?: boolean
  initialValue?: any[]
  onChange?: () => void
  required?: boolean
  labelCol?: { span: number }
  labelAlign?: 'left' | 'right'
  className?: string
}

const DEFAULT_ACCEPT =
  '.doc,.docx,.docm,.xls,.xlsx,xlsm,.csv,.ppt,.pptx,.ppts,.txt,.rtf,.md,.jpg,.jpeg,.png,.bmp,.tif,.tiff,.svg,.eps,.raw,.psd,.ai,.pdf,.ico,.webp,.gif'
export const MAX_FILES_COUNT = 50

function FileUploadField(props: FileUploadFieldProps) {
  const {
    label,
    name,
    maxCount = MAX_FILES_COUNT,
    allowLargeFile = false,
    accept = DEFAULT_ACCEPT,
    disabled = false,
    initialValue = [],
    onChange,
    required = false,
    labelCol = { span: 6 },
    labelAlign = 'left',
    className = 'editable-form-order',
  } = props

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e
    }
    return e?.fileList?.map((item) => {
      return { ...item, status: 'done' }
    })
  }

  const validateFileSize = (file: any) => {
    const maxSize = allowLargeFile ? 52428800 : 5242880 // 50MB or 5MB
    const maxSizeLabel = allowLargeFile ? '50mbps' : '5mbps'

    if (file.size > maxSize) {
      message.error(`Each File cannot be over ${maxSizeLabel}`, 3)
      return Upload.LIST_IGNORE
    }
    return false
  }

  return (
    <Form.Item
      label={label}
      name={name}
      labelCol={labelCol}
      initialValue={initialValue}
      labelAlign={labelAlign}
      className={className}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      rules={
        required
          ? [
              {
                required: true,
                message: 'This field is required',
              },
            ]
          : undefined
      }
    >
      <Upload
        onChange={onChange}
        disabled={disabled}
        maxCount={maxCount}
        multiple
        accept={accept}
        beforeUpload={validateFileSize}
      >
        <Button
          className="upload-button"
          icon={<UploadOutlined />}
          size="large"
        >
          Upload File
        </Button>
      </Upload>
    </Form.Item>
  )
}

export default FileUploadField
